import { render, staticRenderFns } from "./Boxplotchart.vue?vue&type=template&id=3442fbb9&"
import script from "./Boxplotchart.vue?vue&type=script&lang=js&"
export * from "./Boxplotchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports